import { useEffect, useState } from "react";
import { useLogin } from "./hooks/useLogin";
import { toast } from "react-toastify";
import { Form, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";

const Login = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { login, isLoading, error } = useLogin();

  const handleSubmit = async (e) => {
    e.preventDefault();

    await login(username, password);
  };

  useEffect(() => {
    if (error) {
      toast.error(error)
    }
  }, [error])

  return (
    <div className="d-flex justify-content-center login-form">
      <Form onSubmit={handleSubmit}>
        <Form.Group
          className="mb-3"
          controlId="formBasicEmail">
          <Form.Label>Användarnamn</Form.Label>
          <Form.Control
            size="lg"
            type="text"
            placeholder="Skriv in användarnamn"
            onChange={(e) => setUsername(e.target.value)}
            value={username} />
        </Form.Group>

        <Form.Group
          className="mb-3"
          controlId="formBasicPassword">
          <Form.Label>Lösenord</Form.Label>
          <Form.Control
            size="lg"
            type="password"
            placeholder="Lösenord"
            onChange={(e) => setPassword(e.target.value)}
            value={password} 
            autoComplete="on"/>
        </Form.Group>
        <Button
          variant={props.theme === 'dark' ? 'light' : 'primary '}
          disabled={isLoading}
          type="submit">
          Logga in
        </Button>
      </Form>
    </div>
  );
};

export default Login;
